import Vuex from 'vuex';
import Vue from 'vue';
import { getSystemInfo } from '../utils';

Vue.use(Vuex);

function getUser() {
  let userInfo = localStorage.getItem('user_info') || {};
  try {
    return JSON.parse(userInfo);
  } catch (error) {
    return {};
  }
}

export default new Vuex.Store({
  state: {
    //登陆标识
    hasLogin: false,

    //登录用户信息
    userInfo: getUser(),

    //业务数据
    businessData: {},

    systemInfo: getSystemInfo(),
  },
  mutations: {
    login(state, provider) {
      state.hasLogin = true;
      state.userInfo = provider;
      localStorage.setItem('user_info', JSON.stringify(state.userInfo));
    },
    logout(state) {
      state.hasLogin = false;
      state.userInfo = {};
      localStorage.removeItem('user_info');
    },
    setBusinessData(state, data) {
      state.businessData = Object.assign({}, state.businessData, data);
      localStorage.setItem('business_data', JSON.stringify(state.businessData));
    },
    setUserInfo(state, data) {
      const userInfo = JSON.parse(localStorage.getItem('user_info'));
      state.userInfo = Object.assign({}, userInfo, data);
      localStorage.setItem('user_info', JSON.stringify(state.userInfo));
    },
    setLoadTime(state, time) {
      state.systemInfo.loadTime = time;
    },
  },
  getters: {
    getUserInfo: state => (key = '') => {
      let data =
        Object.keys(state.userInfo).length > 0
          ? state.userInfo
          : JSON.parse(localStorage.getItem('user_info'));
      if (key && data.hasOwnProperty(key)) {
        return data[key];
      }

      return data;
    },
    checkLogin: state => (redirect = '') => {
      let info = localStorage.getItem('user_info');
      if (info !== 'undefined' && typeof info === 'string' && info.length > 0) {
        let loginInfo = JSON.parse(info);
        if (loginInfo && loginInfo.token) {
          localStorage.setItem('user_info', JSON.stringify(loginInfo));

          return true;
        }
      }

      return false;
    },
    getBusinessData: state => (key = '') => {
      let data =
        Object.keys(state.businessData).length > 0
          ? state.businessData
          : JSON.parse(localStorage.getItem('business_data'));

      if (key && data && data.hasOwnProperty(key)) {
        return data[key];
      }

      return data;
    },
  },
  actions: {},
});
